import{c as createStore}from"./index-b71e0f8e.js";var _a=createStore({loginManager:null}),state=_a.state,onChange=_a.onChange;export{state as s};